
import React from "react";
import { Modal, Box, Typography, Grid, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import CloseIcon from '@mui/icons-material/Close';

const JobDatesPopup = ({ open, onClose, title, rows, columns }) => {

    return (
        <Modal open={open} onClose={onClose} aria-labelledby="modal-title">
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "90%",
                    maxWidth: 800,
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                }}
            >

                <Box sx={{ display: "flex", justifyContent: "flex-end", }}>

                    <CloseIcon sx={{ cursor: "pointer" }} onClick={onClose} />

                </Box>
                {title && (
                    <Typography id="modal-title" variant="h6" sx={{ mb: 2 }}>
                        {title}
                    </Typography>
                )}

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Box sx={{ height: 400, width: "100%" }}>
                            {/* <DataGrid
                                rows={rows}
                                columns={columns}
                                pageSize={5}
                                rowsPerPageOptions={[5]}
                                hideFooterPagination
                                rowHeight={30}
                                disableSelectionOnClick
                                sx={{
                                    "& .MuiDataGrid-columnHeader": {
                                        backgroundColor: "#b3b3b3",
                                    },
                                }}
                            /> */}
                            <DataGrid
                                rows={rows}
                                columns={columns}
                                pageSize={10}
                                rowsPerPageOptions={[10, 25, 50, 100]}
                                pagination
                                rowHeight={30}
                                disableSelectionOnClick
                                sx={{
                                    "& .MuiDataGrid-columnHeader": {
                                        backgroundColor: "#b3b3b3",
                                    },
                                }}
                            />
                        </Box>
                    </Grid>
                </Grid>


            </Box>
        </Modal>
    );
};

export default JobDatesPopup;
